import { inject, provideAppInitializer } from '@angular/core'
import { firstValueFrom, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { WhiteLabelService } from '../services/white-label.service'
import { ApiResponse } from '../types/response.type'

function initializeWhiteLabelPermissions(): () => Promise<ApiResponse<
	{ SELF_REGISTER_ALLOWED: boolean; LOGIN_HUMAN_VERIFICATION?: boolean; UI_SKIN_KEY?: string; ui_skin_key?: string }[]
> | null> {
	const whiteLabelService = inject(WhiteLabelService)

	return () => {
		return firstValueFrom(
			whiteLabelService.fetchPermissions().pipe(
				catchError((error) => {
					console.error('Error fetching white label permissions:', error)
					return of(null)
				}),
			),
		)
	}
}

export const provideWhiteLabelPermission = () =>
	provideAppInitializer(() => {
		const initializerFn = initializeWhiteLabelPermissions()
		return initializerFn()
	})
